import script from "./ValidateAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidateAccount.vue?vue&type=script&setup=true&lang=js"

import "./ValidateAccount.vue?vue&type=style&index=0&id=ce7f42d4&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce7f42d4"]])

export default __exports__